export const counterLimits = {
  electricity: 40,
  serviceWater: 40,
  coldWater: 40,
  heating: 40,
  cooling: 40,
};
